export default __webpack_public_path__ + "static/media/33.948886a0.jpg";